import { z } from "zod";
import { COMPANY_STATUS_KEY_TYPE } from "../common/enum";

export const simpleSearchFormSchema = z.object({
	name: z.string().optional(),
	corporationName: z.string().optional(),
	employeeIds: z.array(z.string()).optional().default([]),
	companyStatus: z.array(COMPANY_STATUS_KEY_TYPE).optional().default([]),
	areaBlockId: z.number().optional(),
});

export type SimpleSearchFormType = z.infer<typeof simpleSearchFormSchema>;